/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Rv_Pros_1Inputs */

const en_pc_rv_pros_1 = /** @type {(inputs: Pc_Rv_Pros_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free and open source, no subscription or account`)
};

const zh_pc_rv_pros_1 = /** @type {(inputs: Pc_Rv_Pros_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开源，无需订阅和账号`)
};

/**
* | output |
* | --- |
* | "Free and open source, no subscription or account" |
*
* @param {Pc_Rv_Pros_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_rv_pros_1 = /** @type {((inputs?: Pc_Rv_Pros_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Rv_Pros_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_rv_pros_1(inputs)
	return zh_pc_rv_pros_1(inputs)
});
export { pc_rv_pros_1 as "pc.rv.pros.1" }